import ShareModal from '~/javascripts/components/ShareModal';

const ProjectShareModal = ({
  communityName,
  contentfulProjectShareContent,
  peopleServed,
  projectUrl,
}) => {
  const headerText = () => 'It&rsquo;s time to celebrate!';

  const subheaderText = () => {
    if (peopleServed) {
      return `${peopleServed} people in ${communityName} have clean water thanks to your&nbsp;generosity. Share the good news.`;
    } else {
      return `People in ${communityName} have clean water thanks to your&nbsp;generosity. Share the good news.`;
    }
  };

  return (
    <ShareModal
      defaultSocialShareContent={contentfulProjectShareContent}
      headerText={headerText()}
      modalId='project-share-modal'
      shareUrl={projectUrl}
      subheaderText={subheaderText()}
    />
  );
};

export default ProjectShareModal;
